import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TriggerableTypes, variablesIcons } from '../../../constants/constants';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../store/store';
import { Select } from 'antd';
const { Option } = Select

const TriggerTypeSelect = ({ box, triggerType, record }) => {
  const { t } = useTranslation()
  const updateTrigger = useStore(({ updateTrigger }) => updateTrigger)
  const isOffer = useStore(({ currentTemplate }) => currentTemplate.templatable === 'offer')
  const hasCostingActivated = useStore(({ hasCostingActivated }) => hasCostingActivated)
  const hasCompanyWorkFA = useStore(({ hasCompanyWorkFA }) => hasCompanyWorkFA)
  const zoneIcon = useStore(({ zoneIcon }) => zoneIcon)

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
    }}>
      <Select
        popupClassName="trigger-select-type"
        bordered={false}
        showSearch={false}
        optionLabelProp="label"
        value={triggerType}
        suffixIcon={triggerType ? null : undefined}
        onSelect={(type) => updateTrigger(record.id, box.id, { type })}
        disabled={record.from_linked_section}
      >
        {Object.values(TriggerableTypes)
          .filter((type) => {
            if (type === 'optional-zone' || type === 'zone-name') {
              return (!isOffer && hasCostingActivated);
            }
            if (type === 'framework-agreement-opportunity') {
              return hasCompanyWorkFA;
            }
            return true;
          })
          .map((type) =>
            <Option key={type} value={type} label={type === 'zone-name' ? <i className={zoneIcon} />
              : <FontAwesomeIcon icon={variablesIcons[type]} />}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8
              }}>
                {type === 'zone-name' ? <i className={zoneIcon} />
                  : <FontAwesomeIcon icon={variablesIcons[type]} />}
                {t(type)}
              </div>
            </Option>
          )
        }
      </Select>
    </div>
  )
}

export default TriggerTypeSelect
